/* ─── Badge Service — Cloud Function wrappers ────────────────────── */

import { httpsCallable } from 'firebase/functions';
import { FIREBASE_FUNCTIONS } from '../firebaseConfig';
import type { UserBadges } from '../types/social';

const getUserBadgesEurW = httpsCallable(FIREBASE_FUNCTIONS, 'getUserBadgesEurW');
const calculateUserBadgesEurW = httpsCallable(FIREBASE_FUNCTIONS, 'calculateUserBadgesEurW');

/** Get badges for a user (cached, auto-calculated if missing) */
export async function getUserBadges(userId: string): Promise<UserBadges> {
  const res = await getUserBadgesEurW({ userId });
  const data = res.data as any;
  return {
    badges: data.badges || {},
    totalBadges: data.totalBadges || 0,
    lastUpdated: data.lastUpdated,
  };
}

/** Force recalculate badges for a user */
export async function recalculateBadges(userId: string): Promise<UserBadges> {
  const res = await calculateUserBadgesEurW({ userId });
  const data = res.data as any;
  return {
    badges: (data.earnedBadges || []).reduce(
      (acc: Record<string, any>, b: any) => ({ ...acc, [b.id]: b }),
      {}
    ),
    totalBadges: data.totalBadges || 0,
  };
}
